import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import categories from '../../data/categories';
import tools from '../../data/tools';

/**
 * Компонент Breadcrumbs - хлебные крошки для навигации
 */
const Breadcrumbs = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(segment => segment);
  
  // Если мы на главной странице, не показываем хлебные крошки
  if (pathSegments.length === 0) {
    return null;
  }
  
  // Функция для получения имени категории по slug
  const getCategoryName = (slug) => {
    const category = categories.find(cat => cat.slug === slug);
    return category ? category.name : slug;
  };
  
  // Функция для получения имени инструмента по id
  const getToolName = (toolId) => {
    const tool = tools.find(tool => tool.id === toolId);
    return tool ? tool.name : toolId;
  };
  
  // Функция для получения имени подинструмента по id
  const getSubToolName = (toolId, subToolId) => {
    const tool = tools.find(tool => tool.id === toolId);
    if (tool && tool.subTools) {
      const subTool = tool.subTools.find(sub => sub.id === subToolId);
      return subTool ? subTool.name : subToolId;
    }
    return subToolId;
  };
  
  // Построение хлебных крошек на основе текущего пути
  const breadcrumbs = [];
  
  // Добавляем "Главная" как первый элемент
  breadcrumbs.push({
    name: 'Главная',
    path: '/',
  });
  
  // Обрабатываем другие сегменты пути
  if (pathSegments[0] === 'category' && pathSegments[1]) {
    breadcrumbs.push({
      name: getCategoryName(pathSegments[1]),
      path: `/category/${pathSegments[1]}`,
    });
  } else if (pathSegments[0] === 'tools' && pathSegments[1] && pathSegments[2]) {
    // Категория (finance, health, etc.)
    breadcrumbs.push({
      name: getCategoryName(pathSegments[1]),
      path: `/category/${pathSegments[1]}`,
    });
    
    // Инструмент (loan-calculator, etc.)
    breadcrumbs.push({
      name: getToolName(pathSegments[2]),
      path: `/tools/${pathSegments[1]}/${pathSegments[2]}`,
    });
    
    // Подинструмент, если есть (annuity, etc.)
    if (pathSegments[3]) {
      breadcrumbs.push({
        name: getSubToolName(pathSegments[2], pathSegments[3]),
        path: `/tools/${pathSegments[1]}/${pathSegments[2]}/${pathSegments[3]}`,
      });
    }
  } else if (pathSegments[0]) {
    // Другие страницы (about, faq, etc.)
    breadcrumbs.push({
      name: pathSegments[0].charAt(0).toUpperCase() + pathSegments[0].slice(1),
      path: `/${pathSegments[0]}`,
    });
  }
  
  return (
    <nav className="py-3">
      <ol className="flex flex-wrap items-center text-sm text-gray-500 dark:text-gray-400">
        {breadcrumbs.map((breadcrumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          
          return (
            <li key={breadcrumb.path} className="flex items-center">
              {index > 0 && (
                <ChevronRight className="mx-2 h-4 w-4 text-gray-400 dark:text-gray-600" />
              )}
              
              {isLast ? (
                <span className="font-medium text-gray-900 dark:text-gray-200">
                  {breadcrumb.name}
                </span>
              ) : (
                <Link 
                  to={breadcrumb.path}
                  className="hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                >
                  {breadcrumb.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;